export type Faq = {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'Is this useful if I am a newer coach?',
    answer:
      'Yes. Functional Ready gives you a clear, professional system from your very first session, while keeping enough technical depth to stay valuable for experienced coaches.',
  },
  {
    question: 'Which client levels does it cover?',
    answer:
      'Every volume includes Beginner, Intermediate and Pro guidance, plus a dedicated 3-level modification guide so you can scale any exercise on the spot.',
  },
  {
    question: 'Does it include equipment-based programming?',
    answer:
      'Yes. Alongside bodyweight foundations you get a full tools volume for kettlebells, resistance bands and med balls, plus clinical protocols and special populations.',
  },
  {
    question: 'Is this a physical or digital product?',
    answer:
      'It is 100% digital. After checkout you get instant access to high-resolution PDFs you can use on tablet, desktop or in print.',
  },
  {
    question: 'How do I receive my purchase?',
    answer:
      'Immediately after payment you receive email access to all 6 volumes and the 5 strategic bonus resources.',
  },
  {
    question: 'What if it is not right for me?',
    answer:
      'You are covered by the 7-day Coach’s Honor guarantee. Download everything, use it in your sessions, and if it is not a fit we refund every cent — and you keep the bonuses.',
  },
  {
    question: 'How is this different from free online resources?',
    answer:
      'Free resources are scattered and disconnected. Functional Ready is one complete system with coherent progressions, ready-to-coach sessions and answers for the situations you actually face on the floor.',
  },
]
